(function () {
  if (
    window.location.pathname.indexOf('design-your-own') !== -1 ||
    window.location.pathname.indexOf('ball-configurator') !== -1 ||
    window.location.pathname.indexOf('sports-ball-configurator') !== -1
  ) return;

  if (typeof Shopify === 'undefined') return;

  function setDotColor(el, s, size) {
    el.style.width = (size || 28) + 'px';
    el.style.height = (size || 28) + 'px';
    el.style.borderRadius = '50%';
    el.style.flexShrink = '0';
    el.style.boxSizing = 'border-box';
    el.style.backgroundSize = 'cover';
    el.style.backgroundPosition = 'center';
    if (!s || !s.swatchStyle) { el.style.backgroundColor = '#ccc'; return; }
    var imgMatch = s.swatchStyle.match(/background-image:\s*url\(([^)]+)\)/);
    if (imgMatch) {
      el.style.backgroundImage = 'url(' + imgMatch[1] + ')';
      el.style.backgroundColor = 'transparent';
    } else if (s.bgColor && s.bgColor !== 'transparent') {
      el.style.backgroundColor = s.bgColor;
    } else {
      el.style.backgroundColor = '#ccc';
    }
  }

  function stripSize(val) {
    // "2 FT (60cm)" -> "2 FT", "20 in (50cm)" -> "20 in"
    return val.replace(/\s*\([^)]*cm[^)]*\)/gi, '').replace(/\s*\([^)]*\)/g, '').trim();
  }

  function init() {
    var mainBtn = document.querySelector('.product-form__submit');
    if (!mainBtn || document.getElementById('sticky-atc-bar')) return;

    // ---- Gather color swatches ----
    var colorData = [];
    var colorInputs = document.querySelectorAll('input[type="radio"][name="Color"], input[type="radio"][name="color"]');
    if (colorInputs.length === 0) {
      colorInputs = document.querySelectorAll('.product-parameters input[type="radio"], .product-form__controls-group input[type="radio"]');
    }
    colorInputs.forEach(function (input) {
      var labelEl = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
      if (!labelEl && input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
        labelEl = input.nextElementSibling;
      }
      var swatchEl = labelEl ? labelEl.querySelector('.color-swatch') : null;
      var swatchStyle = swatchEl ? (swatchEl.getAttribute('style') || '') : '';
      // Try getComputedStyle first (gets actual rendered color from CSS vars)
      var bgColor = '#ccc';
      var hasImage = swatchStyle.indexOf('background-image') !== -1;
      if (swatchEl && !hasImage) {
        var computed = window.getComputedStyle(swatchEl);
        // Try --swatch-color CSS variable first
        var cssVar = computed.getPropertyValue('--swatch-color').trim();
        if (cssVar && cssVar !== 'transparent' && cssVar !== '') {
          bgColor = cssVar;
        } else {
          // Fall back to actual computed background-color
          var computedBg = computed.backgroundColor;
          if (computedBg && computedBg !== 'rgba(0, 0, 0, 0)' && computedBg !== 'transparent') {
            bgColor = computedBg;
          } else {
            // Last resort: parse from style attribute
            var colorMatch = swatchStyle.match(/--swatch-color:\s*([^;]+)/);
            if (colorMatch) bgColor = colorMatch[1].trim();
          }
        }
      }
      colorData.push({ input: input, value: input.value, swatchStyle: swatchStyle, bgColor: bgColor, checked: input.checked });
    });

    // ---- Gather size options ----
    var sizeData = [];
    var sizeInputs = document.querySelectorAll('input[type="radio"][name="Size"], input[type="radio"][name="size"]');
    sizeInputs.forEach(function (input) {
      sizeData.push({ input: input, value: input.value, checked: input.checked });
    });

    var hasColors = colorData.length > 0;
    var hasSizes = sizeData.length > 0;
    var currentColor = colorData.find(function (s) { return s.checked; }) || colorData[0];
    var currentSize = sizeData.find(function (s) { return s.checked; }) || sizeData[0];
    function displaySize(s) { return s ? stripSize(s.value) : 'Size'; }
    var openDrawer = null; // 'color' | 'size' | null

    // ---- Styles ----
    var style = document.createElement('style');
    style.textContent = [
      '#sticky-atc-bar {',
      '  position:fixed;bottom:-200px;left:0;right:0;z-index:9999;',
      '  background:#fff;border-top:1px solid #e0e0e0;',
      '  box-shadow:0 -4px 20px rgba(0,0,0,0.12);',
      '  font-family:inherit;transition:bottom 0.3s ease;',
      '}',
      '#sticky-atc-bar.satc-visible { bottom:0; }',
      '#sticky-atc-row {',
      '  display:flex;align-items:center;justify-content:space-between;',
      '  padding:10px 14px 16px;gap:8px;',
      '}',
      /* Color trigger */
      '.satc-trigger {',
      '  display:flex;align-items:center;gap:7px;',
      '  cursor:pointer;flex:1;min-width:0;',
      '  -webkit-tap-highlight-color:transparent;user-select:none;padding:4px 0;',
      '}',
      '#satc-color-dot {',
      '  width:26px;height:26px;border-radius:50%;flex-shrink:0;',
      '  border:2px solid #111;box-sizing:border-box;',
      '  background-size:cover;background-position:center;',
      '}',
      '.satc-trigger-text {',
      '  font-size:13px;font-weight:500;color:#111;',
      '  white-space:nowrap;overflow:hidden;text-overflow:ellipsis;',
      '}',
      /* Size trigger */
      '#satc-size-trigger {',
      '  display:flex;align-items:center;gap:6px;',
      '  cursor:pointer;flex-shrink:0;',
      '  -webkit-tap-highlight-color:transparent;user-select:none;padding:4px 6px;',
      '  border:1.5px solid #ddd;border-radius:6px;',
      '}',
      '#satc-size-label {',
      '  font-size:13px;font-weight:500;color:#111;white-space:nowrap;',
      '}',
      '#satc-size-chevron { font-size:14px;color:#666;transition:transform 0.2s; }',
      '.satc-chevron { font-size:14px;color:#666;transition:transform 0.2s;flex-shrink:0; }',
      /* ATC button */
      '#sticky-atc-button {',
      '  background:rgb(151,193,255);color:#141414;border:none;',
      '  border-radius:100px;padding:11px 16px;',
      '  font-size:13px;font-weight:600;cursor:pointer;',
      '  white-space:nowrap;letter-spacing:0.04em;text-transform:uppercase;',
      '  flex-shrink:0;-webkit-tap-highlight-color:transparent;',
      '}',
      '#sticky-atc-button:active { background:rgb(111,163,217); }',
      /* Drawers */
      '.satc-drawer {',
      '  overflow:hidden;max-height:0;transition:max-height 0.3s ease;',
      '  border-top:1px solid #e0e0e0;',
      '}',
      '.satc-option-row {',
      '  display:flex;align-items:center;justify-content:space-between;',
      '  padding:12px 14px;cursor:pointer;border-bottom:1px solid #f0f0f0;',
      '  -webkit-tap-highlight-color:transparent;',
      '}',
      '.satc-option-row:last-child { border-bottom:none; }',
      '.satc-option-name { font-size:14px;color:#111;font-weight:400;flex:1; }',
      '.satc-option-row.selected .satc-option-name { font-weight:600; }',
      '.satc-color-dot {',
      '  width:26px;height:26px;border-radius:50%;flex-shrink:0;',
      '  border:1.5px solid rgba(0,0,0,0.15);box-sizing:border-box;',
      '  background-size:cover;background-position:center;',
      '}',
      '.satc-option-row.selected .satc-color-dot { border:2px solid #111;box-shadow:0 0 0 2px #111; }',
      '.satc-size-check { font-size:16px;color:#111;opacity:0; }',
      '.satc-option-row.selected .satc-size-check { opacity:1; }',
    ].join('\n');
    document.head.appendChild(style);

    var bar = document.createElement('div');
    bar.id = 'sticky-atc-bar';

    // Color drawer
    var colorDrawer = document.createElement('div');
    colorDrawer.className = 'satc-drawer';
    colorDrawer.id = 'satc-color-drawer';
    if (hasColors) {
      colorData.forEach(function (s) {
        var row = document.createElement('div');
        row.className = 'satc-option-row' + (s.checked ? ' selected' : '');
        row.setAttribute('data-val', s.value);
        var name = document.createElement('div');
        name.className = 'satc-option-name';
        name.textContent = s.value;
        var dot = document.createElement('div');
        dot.className = 'satc-color-dot';
        setDotColor(dot, s, 26);
        if (s.checked) dot.style.boxShadow = '0 0 0 2px #111';
        row.appendChild(name);
        row.appendChild(dot);
        row.addEventListener('click', function () { pickColor(s); });
        colorDrawer.appendChild(row);
      });
    }

    // Size drawer
    var sizeDrawer = document.createElement('div');
    sizeDrawer.className = 'satc-drawer';
    sizeDrawer.id = 'satc-size-drawer';
    if (hasSizes) {
      sizeData.forEach(function (s) {
        var row = document.createElement('div');
        row.className = 'satc-option-row' + (s.checked ? ' selected' : '');
        row.setAttribute('data-val', s.value);
        var name = document.createElement('div');
        name.className = 'satc-option-name';
        name.textContent = stripSize(s.value);
        var check = document.createElement('div');
        check.className = 'satc-size-check';
        check.textContent = '✓';
        row.appendChild(name);
        row.appendChild(check);
        row.addEventListener('click', function () { pickSize(s); });
        sizeDrawer.appendChild(row);
      });
    }

    // Both drawers go above the main row
    bar.appendChild(colorDrawer);
    bar.appendChild(sizeDrawer);

    // Main row
    var mainRow = document.createElement('div');
    mainRow.id = 'sticky-atc-row';

    var dotEl, colorText, sizeLabelEl;

    // Color trigger
    if (hasColors) {
      var colorTrigger = document.createElement('div');
      colorTrigger.className = 'satc-trigger';
      colorTrigger.id = 'satc-color-trigger';

      dotEl = document.createElement('div');
      dotEl.id = 'satc-color-dot';
      setDotColor(dotEl, currentColor, 26);
      dotEl.style.border = '2px solid #111';

      colorText = document.createElement('span');
      colorText.className = 'satc-trigger-text';
      colorText.id = 'satc-color-text';
      colorText.textContent = currentColor ? currentColor.value : '';

      var colorChevron = document.createElement('span');
      colorChevron.className = 'satc-chevron';
      colorChevron.id = 'satc-color-chevron';
      colorChevron.textContent = '⌃';
      colorTrigger.appendChild(dotEl);
      colorTrigger.appendChild(colorText);
      colorTrigger.appendChild(colorChevron);
      colorTrigger.addEventListener('click', function () { toggleDrawer('color'); });
      mainRow.appendChild(colorTrigger);

      // Sync from main page
      colorData.forEach(function (s) {
        if (s.input) {
          s.input.addEventListener('change', function () {
            if (s.input.checked) {
              colorText.textContent = s.value;
              setDotColor(dotEl, s, 26);
              dotEl.style.border = '2px solid #111';
              updateColorDrawer(s.value);
            }
          });
        }
      });
    }

    // Size trigger
    if (hasSizes) {
      var sizeTrigger = document.createElement('div');
      sizeTrigger.id = 'satc-size-trigger';

      sizeLabelEl = document.createElement('span');
      sizeLabelEl.id = 'satc-size-label';
      sizeLabelEl.textContent = currentSize ? stripSize(currentSize.value) : 'Size';

      var sizeChevron = document.createElement('span');
      sizeChevron.id = 'satc-size-chevron';
      sizeChevron.textContent = '⌃';

      sizeTrigger.appendChild(sizeLabelEl);
      sizeTrigger.appendChild(sizeChevron);
      sizeTrigger.addEventListener('click', function () { toggleDrawer('size'); });
      mainRow.appendChild(sizeTrigger);

      // Sync from main page
      sizeData.forEach(function (s) {
        if (s.input) {
          s.input.addEventListener('change', function () {
            if (s.input.checked) {
              sizeLabelEl.textContent = stripSize(s.value);
              updateSizeDrawer(s.value);
            }
          });
        }
      });
    }

    // ATC button
    var btn = document.createElement('button');
    btn.id = 'sticky-atc-button';
    btn.type = 'button';
    btn.textContent = 'Add To Cart';
    btn.addEventListener('click', function () {
      closeDrawers();
      mainBtn.click();
      btn.textContent = 'Adding...';
      btn.style.opacity = '0.7';
      setTimeout(function () {
        btn.textContent = 'Added \u2713';
        btn.style.opacity = '1';
        setTimeout(function () { btn.textContent = 'Add To Cart'; }, 1500);
      }, 700);
    });
    mainRow.appendChild(btn);
    bar.appendChild(mainRow);
    document.body.appendChild(bar);

    // ---- Functions ----
    function toggleDrawer(which) {
      var isOpen = openDrawer === which;
      closeDrawers();
      if (!isOpen) {
        openDrawer = which;
        if (which === 'color') {
          colorDrawer.style.maxHeight = (colorData.length * 52 + 'px');
          var cc = document.getElementById('satc-color-chevron');
          if (cc) cc.style.transform = 'rotate(180deg)';
        }
        if (which === 'size') {
          sizeDrawer.style.maxHeight = (sizeData.length * 52 + 'px');
          var sc = document.getElementById('satc-size-chevron');
          if (sc) sc.style.transform = 'rotate(180deg)';
        }
      }
    }

    function closeDrawers() {
      openDrawer = null;
      colorDrawer.style.maxHeight = '0';
      sizeDrawer.style.maxHeight = '0';
      var cc = document.getElementById('satc-color-chevron');
      if (cc) cc.style.transform = 'rotate(0deg)';
      var sc = document.getElementById('satc-size-chevron');
      if (sc) sc.style.transform = 'rotate(0deg)';
    }

    function pickColor(s) {
      if (colorText) colorText.textContent = s.value;
      if (dotEl) { setDotColor(dotEl, s, 26); dotEl.style.border = '2px solid #111'; }
      updateColorDrawer(s.value);
      if (s.input) { s.input.click(); s.input.dispatchEvent(new Event('change', { bubbles: true })); }
      closeDrawers();
    }

    function pickSize(s) {
      if (sizeLabelEl) sizeLabelEl.textContent = stripSize(s.value);
      updateSizeDrawer(s.value);
      if (s.input) { s.input.click(); s.input.dispatchEvent(new Event('change', { bubbles: true })); }
      closeDrawers();
    }

    function updateColorDrawer(value) {
      colorDrawer.querySelectorAll('.satc-option-row').forEach(function (row) {
        var active = row.getAttribute('data-val') === value;
        row.classList.toggle('selected', active);
        var d = row.querySelector('.satc-color-dot');
        if (d) { d.style.border = active ? '2px solid #111' : '1.5px solid rgba(0,0,0,0.15)'; d.style.boxShadow = active ? '0 0 0 2px #111' : 'none'; }
      });
    }

    function updateSizeDrawer(value) {
      sizeDrawer.querySelectorAll('.satc-option-row').forEach(function (row) {
        row.classList.toggle('selected', row.getAttribute('data-val') === value);
      });
    }

    // Show/hide
    var visible = false;
    function checkVisibility() {
      var rect = mainBtn.getBoundingClientRect();
      var shouldShow = rect.bottom < 0 || rect.top > window.innerHeight;
      if (shouldShow && !visible) { bar.classList.add('satc-visible'); visible = true; nudgeScrollTop(true); }
      else if (!shouldShow && visible) { bar.classList.remove('satc-visible'); closeDrawers(); visible = false; nudgeScrollTop(false); }
    }
    // Keep scroll-to-top button above sticky bar
    function nudgeScrollTop(up) {
      var barH = bar.offsetHeight || 64;
      document.querySelectorAll('.scroll-top, .scroll-top__block').forEach(function(el) {
        el.style.bottom = up ? (barH + 8) + 'px' : '';
      });
    }

    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility, { passive: true });
    setTimeout(checkVisibility, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
